import React, {useContext, useState} from "react";
import useTranslate from "../../../../modules/local/useTranslate";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import EventContext from "../EventContext";
import {HeaderBlock} from "../../../MainPage/components/HeaderBlock";
import {BiSolidChurch} from "react-icons/bi";
import {Avatar} from "antd";
import getAvatar from "../../../../helpers/getAvatar";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import getTitle from "../../../../helpers/getTitle";
import {getId, getType} from "../../../../apis/model/base";
import {member_getMembers_Api} from "../../../../apis";
import {renderIf, renderIfElse, renderSelf, withPagerWrapper} from "../../../Shared";
import renderPagingWrapper from "../../../MainPage/functions/renderPagingWrapper";
import Translate from "../../../../modules/local/Translate";
import {FaUserSecret} from "react-icons/fa6";
import {BsPersonFill} from "react-icons/bs";
import {ifThenElseMultipleConditions} from "../../../../helpers/ifThenElseMultipleConditions";
import {RequiredSystemAdmin} from "../../../../components/RequiredAdmin";
import {ConversationWith} from "../../factory/createChatButton";
import {RiMessage3Line} from "react-icons/ri";
import CustomLazyPaginationWrapper from "../../../../modules/asyncCache/components/CustomLazyPaginationWrapper";
import renderPagingLoading from "../../../MainPage/functions/renderPagingLoading";
import EmptyHolder from "../../../../components/EmptyHolder";
import {bindQueryParams} from "../../functions/routerHelper";
import {renderShowMore} from "../../../MainPage/functions/renderLimitLoadMore";
import {FaUserTie} from "react-icons/fa";
import _ from "lodash";

const EventOwner = () => {
    const t = useTranslate()

    const {event} = useContext(EventContext)

    const {owner} = event ?? {}

    return (
        <div className="flex flex-col gap-3">
            <HeaderBlock
                size={26}
                icon={<BiSolidChurch size={14} className="text-primary-400"/>}
                title="organization by"
                className="bg-primary-50 text-sm text-primary-600"
            />
            <div className="ml-2 flex items-center gap-2">
                <Avatar
                    src={getAvatar(owner)}
                    icon={<BiSolidChurch className="text-color-300"/>}
                    className="flex flex-center background-200 border border-color-50 rounded-md"
                />
                <div className="flex flex-col flex-1">
                    <Link
                        className="text-primary font-bold text-sm max-lines-1 no-underline leading-tight"
                        to={getLinkToDetail(owner)}>
                        {getTitle(owner)}
                    </Link>
                    <span className="font-medium text-xs text-blue-600 italic">
                        {t(getType(owner))}
                    </span>
                </div>
            </div>
        </div>
    )
}

const EventMember = ({alwaysVisible = false}) => {
    const t = useTranslate()
    const {event} = useContext(EventContext)

    const [limit, setLimit] = useState(5)

    const [id, prop] = [getId(event), getType(event)]
    const apiInfo = member_getMembers_Api
    const lookupKey = apiInfo.path.replace(':id', id).replace(':prop', prop)

    const renderWrap = (alwaysVisible ? renderSelf : withPagerWrapper)(
        renderPagingWrapper()
    )

    const renderMember = (member) => {
        const {user: item} = member ?? {}

        return (
            <Translate key={getId(item)}>
                {(t) => renderIfElse(
                    member?.visible !== 1,
                    <div className="flex items-center gap-2">
                        <Avatar
                            size={28}
                            icon={<FaUserSecret size={14} className="text-color-400"/>}
                            className="flex flex-center background-200"
                        />
                        <div className="flex flex-col flex-1">
                            <div
                                className="font-medium text-xs text-color-200 tracking-wider italic leading-tight truncate">
                                {t('anonymous member')}
                            </div>
                            <span className="text-2xs text-color-400 italic tracking-wider leading-tight">
                                {t('as requested by the user')}
                            </span>
                        </div>
                    </div>,
                    <div className="flex items-center gap-2">
                        <Avatar
                            size={28}
                            src={getAvatar(item)}
                            icon={<BsPersonFill size={14} className="text-color-400"/>}
                            className="flex flex-center background-200"
                        />
                        <div className="flex flex-col flex-1 truncate">
                            <Link
                                to={getLinkToDetail(item)}
                                className="font-semibold text-sm text-color-000 leading-tight no-underline truncate">
                                {getTitle(item)}
                            </Link>
                            <div className="flex items-center justify-between gap-2">
                                {ifThenElseMultipleConditions(
                                    <span
                                        className="font-medium text-2xs text-color-400 italic tracking-wider leading-tight">
                                        {t('member')}
                                    </span>,
                                    member?.role_id === 1,
                                    <span
                                        className="font-medium text-2xs text-primary-600 italic tracking-wider leading-tight">
                                        {t('owner')}
                                    </span>,
                                    member?.role_id === 2,
                                    <span
                                        className="font-medium text-2xs text-blue-500 italic tracking-wider leading-tight">
                                        {t('admin')}
                                    </span>,
                                )}
                                <RequiredSystemAdmin>
                                    <ConversationWith
                                        params={{
                                            receiver_id: getId(item),
                                        }}
                                        render={(__, {onClick}) => (
                                            <div
                                                onClick={onClick}
                                                className="flex items-center gap-1 text-2xs text-color-300 hover:text-primary italic tracking-wide leading-tight cursor-pointer">
                                                {t('send message')}
                                                <RiMessage3Line size={10}/>
                                            </div>
                                        )}
                                    />
                                </RequiredSystemAdmin>
                            </div>
                        </div>
                    </div>
                )}
            </Translate>
        )
    }


    return (
        <div className="flex flex-col gap-3">
            <HeaderBlock
                size={26}
                icon={<BsPersonFill size={14} className="text-color-400"/>}
                title="co-hosts"
                className="background-200 text-sm text-color-200"
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <span className="flex-1 uppercase text-sm font-bold text-color-200">
                            {t('list of members')}
                        </span>
                        <span className="text-2xs text-primary-500 italic lowercase tracking-wide">
                            {event?.total?.members} {t('member')}
                        </span>
                    </div>
                )}
            />
            <div className="ml-2 flex flex-col gap-3">
                <CustomLazyPaginationWrapper
                    auto={false}
                    sample={limit}
                    id={lookupKey}
                    apiInfo={apiInfo}
                    renderWrap={renderWrap}
                    renderItem={renderMember}
                    alwaysVisible={alwaysVisible}
                    renderLoading={renderPagingLoading}
                    renderEmpty={() => <EmptyHolder/>}
                    query={bindQueryParams([{id}, {prop}])}
                    renderLoadMoreButton={renderShowMore([limit, setLimit])}
                />
            </div>
        </div>
    )
}

const EventSpeaker = () => {
    const t = useTranslate()

    const {event} = useContext(EventContext)

    const {speakers = []} = event ?? {}

    return renderIf(
        speakers.length > 0,
        <div className="flex flex-col gap-3">
            <HeaderBlock
                size={26}
                icon={<FaUserTie size={14} className="text-blue-400"/>}
                title="speakers"
                className="bg-blue-100 text-sm text-blue-600"
            />
            <div className="ml-2 flex flex-col gap-3">
                {speakers.map((e, i) => (
                    <div key={i} className="flex items-center gap-2">
                        <Avatar
                            size={28}
                            src={_.get(e, 'speaker.avatar')}
                            icon={<FaUserTie size={12} className="text-color-400"/>}
                            className="flex flex-center background-200"
                        />
                        <Link
                            className="font-bold text-color-000 text-sm max-lines-1 no-underline leading-tight"
                            to={getLinkToDetail(e.speaker)}>
                            {_.get(e, 'speaker_name')}
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    )
}

export const EventMembers = ({}) => {
    const t = useTranslate()
    const {isSm, isLg} = useContext(LayoutContext)

    return (
        <div className="flex flex-col gap-6">

            <EventOwner/>
            <EventSpeaker/>
            <EventMember/>
        </div>
    )
}